// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2V4tG","error":"Textarea_error__3XPCy","readonly":"Textarea_readonly__e8Yhw","disabled":"Textarea_disabled__liMeI"};